import { IMainState } from '@cyntler/react-doc-viewer/dist/store/mainStateReducer';
import {
  Button,
  Heading,
  Icon,
  IconButton,
  IconType,
} from 'copilot-design-system';

import { PreviewTooltip } from 'src/legacy/components/Files/ChannelContent/components/filePreviewDialog/PreviewTooltip';

type StateType = IMainState & {
  onClose(): void;
  onDownload?(): void;
  handleGoToFilesTab?(): void;
};

const fileExtensionsToIconNames: { [key: string]: IconType } = {
  docx: 'Doc',
  pdf: 'PDF',
  xlsx: 'Excel',
  zip: 'ZIP',
  jpg: 'JPG',
  jpeg: 'JPG',
  png: 'PNG',
  mp3: 'MP3',
  mp4: 'MP4',
  mov: 'MOV',
  avi: 'Movie',
  gif: 'GIF',
  txt: 'File',
  csv: 'CSV',
  svg: 'SVG',
  iso: 'File',
};

export const FilePreviewHeader = (state: StateType) => {
  // it was hard to find the type of state, so I had to cast it to the type I needed
  const { currentDocument, onClose, onDownload, handleGoToFilesTab } = state;
  const fileIcon =
    fileExtensionsToIconNames[
      currentDocument?.fileName?.split('.').pop() || ''
    ];

  if (!currentDocument) {
    return null;
  }

  return (
    <div
      className="px-2 flex items-center bg-black/60 h-16 text-white fixed z-10 "
      style={{ width: '-webkit-fill-available' }}
    >
      <PreviewTooltip label="Close">
        <IconButton
          className="hover:bg-[#4B4B4B] text-white mr-3 border-none"
          variant="minimal"
          onClick={onClose}
          icon="Close"
          label="close"
        />
      </PreviewTooltip>
      <div className="flex mx-auto items-center gap-[6px] text-white">
        {fileIcon && <Icon className="h-[14px]" icon={fileIcon} />}
        <Heading
          size="base"
          className="text-[14px] truncate max-w-[250px] xs:block sm:hidden"
        >
          {currentDocument.fileName || ''}
        </Heading>

        <Heading size="lg" className="hidden xs:hidden sm:block">
          {currentDocument.fileName || ''}
        </Heading>
      </div>
      {onDownload && (
        <PreviewTooltip label="Download">
          <IconButton
            className="bg-white text-black hover:bg-gray-100 text-lg"
            onClick={onDownload}
            icon="Download"
            label="download"
            variant="minimal"
          />
        </PreviewTooltip>
      )}
      {handleGoToFilesTab && (
        <PreviewTooltip label="Go to Files">
          <Button
            className="m-2"
            variant="secondary"
            onClick={handleGoToFilesTab}
            label="Files"
            suffixIcon="ArrowRight"
          />
        </PreviewTooltip>
      )}
    </div>
  );
};
